import { useTranslate } from '@tolgee/react';
import Head from 'next/head';
import { useEffect } from 'react';

import { Loader } from '../components/_atoms/_Loader';
import { Center } from '../components/_atoms/Center';
import { NextPageWithLayout } from '../components/layouts';
import { configureStore } from '../utils/store';

const LivePage: NextPageWithLayout = () => {
  const { t } = useTranslate();
  useEffect(() => {
    window.location.assign(`https://${configureStore().config.game.url}`), [];
  });

  return (
    <>
      <Head>
        <title>-</title>
        <meta
          httpEquiv="refresh"
          content={`0;url=https://${configureStore().config.game.url}`}
        />
      </Head>
      <Center
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr',
          gap: '10px',
          justifyItems: 'center',
          alignContent: 'center',
        }}
      >
        <Loader />
        <p>
          {t('Redirecting you to ')}
          {configureStore().config.game.url}
        </p>
      </Center>
    </>
  );
};

export async function getStaticProps() {
  return {
    props: {},
  };
}
export default LivePage;
